import { render, staticRenderFns } from "./AdvProd.vue?vue&type=template&id=d33cbb7a&scoped=true"
import script from "./AdvProd.vue?vue&type=script&lang=js"
export * from "./AdvProd.vue?vue&type=script&lang=js"
import style0 from "./AdvProd.vue?vue&type=style&index=0&id=d33cbb7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33cbb7a",
  null
  
)

export default component.exports